export type UserRole = 'super_admin' | 'admin' | 'user' | 'readonly'

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  super_admin: '超級管理員',
  admin: '管理員',
  user: '一般用戶',
  readonly: '唯讀',
}

export const USER_ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  super_admin: '完整系統權限',
  admin: '可管理主要資料',
  user: '一般操作權限',
  readonly: '僅可查看資料',
}

export type User = {
  id: number
  email: string
  fullname: string
  role: UserRole
  active: boolean
  createdAt: string
  updatedAt: string
}
